module.exports = __webpack_public_path__ + "img/对接业务员.8ea4c5a2.svg";